<template>
  <div>
    <Modal
      :open='isOpen'
      :title='confirmAction.title'
      modal-classes='w-1/3 h-1/2 p-0 absolute'
      title-classes='text-left border-b px-8 pt-5 pb-4'
      content-classes='px-4 pt-5 bg-gray-50 overflow-y-auto pb-20'
      @close-modal='closeModal'
    >
      <template #content>
        <div>
          <div v-html='confirmAction.message'/>
          <div class='flex justify-end'/>
        </div>
      </template>
      <template #buttons>
        <div class='flex justify-end px-2'>
          <button
            type='submit'
            class='my-3 mr-3 items-center rounded-md py-1.5 px-5 text-sm text-white focus:ring-0'
            :class='[sending ? "bg-gray-600/50 hover:bg-gray-500/50 cursor-not-allowed" : "bg-gray-600 hover:bg-gray-500"]'
            @click='sendConfirmedAction'
          >Confirm</button>

          <button
            type='button'
            class='my-3 items-center rounded-md border border-gray-300 bg-white py-1.5 px-5 text-sm text-gray-500 hover:bg-gray-100 focus:ring-0'
            @click='closeModal'
          > Cancel
          </button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script lang="ts">
  import { computed, defineComponent, ref, watch } from 'vue'
  import Modal from '@/components/Modal.vue'
  import { IconComponents } from '@/compositions/useIconComponents'
  import { useAppStore } from '@/store/app'
  import { ConfirmAction } from '@/types/general/ActionType'
  import myZoneServiceProvider from '@/api/serviceProviders/my-zone'
  import { useModuleStore } from '@/store/module'

  export default defineComponent({
    name: 'ConfirmActionModal',
    components: {
      Modal,
      ...IconComponents,
    },
    setup() {
      const isOpen = ref(false)
      const sending = ref(false)

      const confirmAction = computed(() =>{
        if(!useAppStore().confirmAction) return {
          title: '',
          message: '',
          requestConfig: {
          },
        }
        
        return useAppStore().confirmAction
      })

      watch(isOpen, (newValue) => {
        if(!newValue){
          setTimeout(() => {
            useAppStore().confirmAction = undefined
          }, 500) // modal content was emptied before transition finished
        }
      })

      watch(confirmAction, (newValue: ConfirmAction) => {
        if(newValue.title === '') return
        isOpen.value = true
      })

      const closeModal = () => {
        isOpen.value = false
        useModuleStore().refresh = true
      }

      const  sendConfirmedAction = async () => {
        sending.value = true
        const config = confirmAction.value.requestConfig

        if(config.data instanceof FormData){
          config.data.append(confirmAction.value.confirmKey, true)
        }else{
          config.data = JSON.parse(config?.data)
          config.data[confirmAction.value.confirmKey] = true
          config.data = JSON.stringify(config.data)
        }

        await myZoneServiceProvider(config).then(() => {
          sending.value = false
          closeModal()
        })
      }

      return {
        isOpen,
        closeModal,
        confirmAction,
        sendConfirmedAction,
        sending,
      }
    },
  })

</script>
